module.exports = __webpack_public_path__ + "img/0167-eye-crossed.fb4e7bd6.svg";